import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import * as dateutil from '@appbase/util/date-helper';
import { getAmpm, getTimetext, getFullTimetext } from '@reserve/disp-helper';
import modalHelper from '@appbase/util/modal-helper';
import { openReserveCalendarItem } from '@reserve/popup-handler';
import OccurrenceSelect from '@reserve/components/OccurrenceSelect.vue';

@Component({

})
export default class AlldayItem  extends Vue {
    @Prop({ type: Object }) item!: reserve.DateItem;

    allDayEventsModel: reserve.CalendarItem[] = [];

    @Watch('item')
    itemChaged(newVal: reserve.DateItem) {
        this.allDayEventsModel = this.item.events.filter(e => 
            (e.isAllDayEvent &&
              e.id !== 'null' &&
              dateutil.uGetDateFormat_UTC('dd', new Date(e.start)) === this.item.date.getDate().toString()) ||
              (!e.isAllDayEvent && e.id !== 'null' &&
                dateutil.uGetDateFormat_UTC('dd', new Date(e.start)) <= this.item.date.getDate().toString() &&
                dateutil.uGetDateFormat_UTC('dd', new Date(e.end)) >= this.item.date.getDate().toString())
        );        
    }

    created() {
        if(this.item != null) {
            this.itemChaged(this.item);
        }
    }

    getColorClass(event: reserve.CalendarItem) {
        var colorClass: any = {};
        colorClass[event.color] = true;
        return colorClass;
    }

    getFormattedDate(date: string) {
        return dateutil.uGetDateFormat('mm월 dd일', new Date(date));
    }

    isToday(date: string) {
        return dateutil.uGetDateFormat_UTC('dd', new Date(date)) === this.item.date.getDate().toString()
    }

    getTimetext(eventTime: string) {
        return getTimetext(eventTime);
    }

    getAmpm(eventTime: string) {
        return getAmpm(eventTime);
    }

    fulltimeText(event: reserve.CalendarItem): string {
        return getFullTimetext(event);
    }

    onEventDblClick(event: reserve.CalendarItem) {
        if (event.appointmentType === 'Occurrence') {
            modalHelper.show({ component: OccurrenceSelect, force: true, value: event });
        } else if (event.appointmentType === 'Exception') {
            openReserveCalendarItem(event, 'exception');
        } else {
            openReserveCalendarItem(event);
        }
    }
}